import {
  ApiRoute,
  Newsletter,
  NewsletterSchema,
  PresignedReq,
  PresignedResp,
  PresignedRespSchema,
  SubscriptionReq,
  UploadImageResp,
  getApiRoute
} from "@garther/interfaces";
import axios from "axios";

import { ApiClientConfig, BaseApiClient } from "./base-client";

type UploadProgress = {
  percent: number;
  loaded: number;
  total: number;
};

export class PublicApiClient extends BaseApiClient {
  constructor(config: ApiClientConfig) {
    super({
      ...config,
      baseEndpoint: getApiRoute(ApiRoute.PUBLIC),
      requireAuth: false
    });
  }

  async subscribeToNewsletter(request: SubscriptionReq): Promise<Newsletter> {
    return await this.post("subscribe", NewsletterSchema, request, {
      requireAuth: false
    });
  }

  private presigned = async (params: PresignedReq): Promise<PresignedResp> => {
    return await this.get("uploads/presigned", PresignedRespSchema, {
      requireAuth: true,
      params: {
        fileSize: params.fileSize,
        fileName: params.fileName,
        contentType: params.contentType
      }
    });
  };

  uploadImage = async (file: File, onProgress?: (e: UploadProgress) => void): Promise<UploadImageResp> => {
    const presign = await this.presigned({
      fileSize: file.size,
      fileName: file.name,
      contentType: file.type as PresignedReq["contentType"]
    });

    await axios.put(presign.url, file, {
      headers: {
        "Content-Type": file.type
      },
      onUploadProgress: (e) => {
        if (!e.total) return;

        const percent = Math.round((e.loaded / e.total) * 100);

        onProgress?.({
          percent,
          loaded: e.loaded,
          total: e.total
        });

        console.log(`Uploading... ${percent}%`);
      }
    });

    const objUrl = presign.url.split("?")[0];
    if (!objUrl) throw new Error("Cannot parse url");

    return { url: objUrl };
  };
}
